<script>
import { Pie } from "vue-chartjs";
import { API } from "@/api.js";
import { COLORS } from "@/components/colors.js";

export default {
	extends: Pie,
	data: () => ({
		chartdata: {
			labels: [],
			datasets: [
				{
					label: "Data One",
					backgroundColor: COLORS.Tableau20,
					data: [],
				},
			],
		},
		options: {
			responsive: true,
			maintainAspectRatio: true,
			legend: {
				display: true,
				position: "right",
			},
			tooltips: {
				callbacks: {
					label: function (tooltipItem, data) {
						let val =
							data.datasets[tooltipItem.datasetIndex].data[
								tooltipItem.index
							];
						return val + " %";
					},
				},
			},
		},
	}),
	props: {
		mcode: String,
	},
	async mounted() {
		let data = await API.totalNumTicketAss(this.mcode);
		// console.log("data",data)
		// console.log("mcode",this.mcode)
		let kt = data.reduce((acc, d) => {
			return acc + (d.ticketrem == "Remote Assistance" ? d.k : 0);
		}, 0);
		let ka = data.reduce((acc, d) => {
			return acc + (d.ticketrem != "Remote Assistance" ? d.k : 0);
		}, 0);
		// console.log("kt-ka",kt,ka)
		if (kt == 0 && ka == 0) {
			kt = 1;
			ka = 1;
		}
		this.chartdata.labels = ["Remote Assistance","Onsite Assistance"];
		this.chartdata.datasets[0].data = [
			(kt * 100.0) / (kt + ka),
			(ka * 100.0) / (kt + ka),
		];
		this.$emit("total", kt + ka);
        try {
            this.renderChart(this.chartdata, this.options);
        } catch(e){
            // banale errore fake
        }
		
	},
};
</script>
<style></style>
